import { ConcreteTestSet } from '../../../../ConcreteTestSetTrackerContext/types'
import { useColumns } from './hooks/useColumns'
import RelationTable from '../RelationTable'
import { useExpand } from './hooks/useExpand'
import { Report } from '@cims-online/shared'
import { useReportURLDependencies } from 'hooks/useReportURLDependencies'

const Placements: React.FC<ConcreteTestSet> = ({
  concretePlacements,
  concreteMaterial,
  globalId,
}) => {
  const columns = useColumns()
  const expand = useExpand(concreteMaterial?.cureRate ?? null)
  const dependencies = useReportURLDependencies()
  return (
    <RelationTable
      rowKey="globalId"
      columns={columns}
      records={concretePlacements}
      expand={expand}
      actions={{
        header: {
          custom: [
            {
              type: 'externalLink',
              href: Report.ConcreteTestSetPlacements.toURL({
                globalId,
                ...dependencies,
              }),
              label: Report.ConcreteTestSetPlacements.name,
            },
          ],
        },
      }}
    />
  )
}

export default Placements
